import './form.scss'

import DomClass from './../../../js/classes/Dom'

document.querySelectorAll('.form').forEach((form) => {
    if (form.classList.contains('form_no-bind')) return false

    const checkFields = () => {
        const action = form.querySelector('[name="action"]').value,
        patterns = window[`FORM_DATA_MASK__${ action }`],
        keys = Object.keys(patterns)

        let isErrors = false

        const agreementInput = document.querySelector('[name="agreement-check"]')
        agreementInput.classList.remove('form__input_success')
        agreementInput.classList.remove('form__input_error')

        if (!agreementInput.checked) {
            agreementInput.classList.add('form__input_error')
            isErrors = true
        } else {
            agreementInput.classList.add('form__input_success')
        }

        keys.forEach((key) => {
            const input = document.querySelector(`[name="${ key }"]`)
            input.classList.remove('form__input_success')
            input.classList.remove('form__input_error')

            if (!patterns[key].test(input.value)) {
                input.classList.add('form__input_error')
                isErrors = true
            } else {
                input.classList.add('form__input_success')
            }
        })

        return isErrors
    }

    /*

    form.addEventListener('submit', async (e) => {
        e.preventDefault()
        if (checkFields()) return false

        const submit = form.querySelector('[type="submit"]'),
        submitText = submit.textContent

        submit.setAttribute('disabled', 'disabled')
        submit.textContent = 'Отправка..'

        const formData = new FormData(form),
        response = await fetch(form.getAttribute('action'), {
            method: form.getAttribute('method'),
            body: formData
        }),
        result = await response.json(),
        keys = Object.keys(result),
        inputs = []

        let isErrors = false

        keys.forEach((key) => {
            const input = form.querySelector(`[name="${ key }"]`)

            inputs.push(input)

            input.classList.remove('form__input_success')
            input.classList.remove('form__input_error')

            if (result[key]) {
                input.classList.add('form__input_success')
            } else {
                input.classList.add('form__input_error')
                isErrors = true
            }
        })

        submit.textContent = submitText
        submit.removeAttribute('disabled')

        if (!isErrors) {
            inputs.forEach((input) => {
                input.value = ''
                input.classList.remove('form__input_success')
                input.classList.remove('form__input_error')
            })
        }

        return false
    })
    */
})

document.querySelectorAll('.checkbox__input').forEach((checkboxNode) => {
    checkboxNode.addEventListener('change', () => {
        const isChecked = checkboxNode.checked,
        buttonSelector = checkboxNode.getAttribute('data-agreement-binding'),
        buttonNode = buttonSelector ? document.querySelector(buttonSelector) : null

        if (buttonNode) {
            if (isChecked) {
                buttonNode.removeAttribute('disabled')
            } else {
                buttonNode.setAttribute('disabled', 'disabled')
            }
        }
    })
})

document.querySelectorAll('.form .phone-mask').forEach((phoneMaskNode) => {
    DomClass.setMask(phoneMaskNode)
})